import { Link } from 'react-router-dom'
import { ListGroupItem } from 'reactstrap'
import { publishEvent, replaceUnicode, getAttributeValue } from '../../utils'
import { ATTRIBUTE_NAME } from '../../constants'
import './AreaItem.css'

export default function AreaItem({ item }) {
  //console.log('AreaItem rendered', item)
  let text = null
  let pathName = null
  if (item.search) {
    text = replaceUnicode(item.search.name)
    pathName = `/search/${item.search.id}`
  } else {
    text = item.linkText
    pathName = item.linkUrl
    if (!item.linkUrl.includes('/')) {
      pathName = `/custom/${item.linkUrl}`
    }
  }

  function areaClicked() {
    console.log('AreaItem: areaClicked')
    const collapseSidebar = getAttributeValue(ATTRIBUTE_NAME.collapseSidebar)
    if (collapseSidebar === 'Y') {
      publishEvent('SIDEBAR', { className: 'sidebar-collapsed' })
    }
  }

  return (
    <Link to={pathName} target={item.target} onClick={areaClicked} className="area-item-link">
      <ListGroupItem action className="area-item" data-cy={`area-item-${text.toLowerCase().replace(/ /g, '-')}`} >
        {text}
      </ListGroupItem>
    </Link>
  )
}
